import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'app-issue-seller-credit-note-briefly',
    templateUrl: './issue-seller-credit-note-briefly.component.html',
    styleUrl: './issue-seller-credit-note-briefly.component.scss'
})
export class IssueSellerCreditNoteBrieflyComponent {
    currentDate: any;
    startDate: any;
    endDate: any;
    advtCreditRegiInBrieflyFormBeans: any = []
    CredittadvtInBrieflyTotaltds: any;
    CredittadvtInBrieflyTotalother: any;
    CredittadvtInBrieflyTotal: any;
    repName: any;
    offRepName: any;
    issueDates1: any;
    show: boolean;
    reportType: string = 'CreditNotebriefly';
    issueName: any;
    issueDates: any;
    // exportExcel(arg0: string) {
    //   throw new Error('Method not implemented.');
    // }
    constructor(
        private dialogRef: MatDialogRef<IssueSellerCreditNoteBrieflyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
        // this.contractDetailsForm = this.fb.group({
        //   start: ['', Validators.required],
        //   end: ['', Validators.required],
        //   // other form controls
        // });
    }

    ngOnInit(): void {
        this.startDate = this.data.startDate;
        this.endDate = this.data.endDate;
        this.repName = this.data.rep_name;
        this.issueName = this.data.issue_name;
        this.issueDates = this.data.issue_date;
        this.offRepName = this.data.off_rep_name;
        this.reportType = this.data.reportType;
        this.currentDate = new Date();
        this.getCreditRegiInBriefly();
    }

    getCreditRegiInBriefly() {
        const req: any = {
            rep_name: this.repName,
            start_date: this.startDate,
            end_date: this.endDate,
            off_rep_name: this.offRepName,
            issue_name: this.issueName,
            issue_date: this.issueDates
        };
        this.service.getIssueCreditRegiInBriefly(req).subscribe((data: any) => {
            console.log("ADVT Indetailscredit Data=", data);
            this.advtCreditRegiInBrieflyFormBeans = (data as any);;

            // Reset totals
            this.CredittadvtInBrieflyTotal = 0;
            this.CredittadvtInBrieflyTotaltds = 0;
            this.CredittadvtInBrieflyTotalother = 0;

            // Calculate totals
            for (let repData of this.advtCreditRegiInBrieflyFormBeans) {

                this.CredittadvtInBrieflyTotal += parseInt(repData.credit_v_amt) || 0;
                this.CredittadvtInBrieflyTotaltds += parseInt(repData.tds_amt) || 0;
                this.CredittadvtInBrieflyTotalother += parseInt(repData.other_credit_amt) || 0;

            }
        });
    }
    exportExcel(fileName: string): void {
        /* table id is passed over here */
        let element = document.getElementById('print-section1');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
    }

    printPage3() {
        this.show = true;
        const printSection = document.getElementById('print-section');
        if (!printSection) {
            console.error("Print section not found!");
            return;
        }

        const printContent = printSection.innerHTML;

        const screenWidth = window.screen.availWidth;
        const windowWidth = 1400;
        const leftPosition = screenWidth - windowWidth - 50;

        const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(`
          <html>
              <head>
                  <title>Print Report</title>
                  <style>
                      @media print {
                          @page {
                              size: A3 landscape;
                              margin: 3mm;
                          }
                          body {
                              font-family: Arial, sans-serif;
                              margin: 0;
                              padding: 0;
                              font-size: 10px !important;
                          }
                          .print-section {
                              width: 100%;
                              margin: 0 auto;
                              padding: 0;
                          }
                          table {
                              width: 100% !important;
                              border-collapse: collapse;
                              table-layout: auto;
                              page-break-inside: auto;
                          }
                          tr {
                              page-break-inside: avoid;
                              page-break-after: auto;
                          }
                          th, td {
                              padding: 3px 5px !important;
                              border: 1px solid black !important;
                              font-size: 10px;
                              line-height: 1.3;
                              word-wrap: break-word;
                              overflow-wrap: break-word;
                          }
                          th {
                              background-color: #f2f2f2;
                          }
                          tr {
                              border-bottom: 1px solid black !important;
                          }
                          tr.header-row {
                              display: table-header-group;
                          }
                          td:nth-child(1) {
                              width: 1%;
                              text-align: left !important;
                          }
                          td:nth-child(2),
                          td:nth-child(3),
                          td:nth-child(4),
                          td:nth-child(5),
                          td:nth-child(6),
                          td:nth-child(8) {
                              text-align: left !important;
                          }
                          td:nth-child(5) {
                              width: 5%;
                              white-space: normal;
                          }
                          td.advt-name {
                              max-width: 160px;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                          }
                          td:nth-child(n+12),
                          td.amount,
                          td[data-type="number"] {
                              text-align: right !important;
                          }
                          td.text,
                          td[data-type="string"] {
                              text-align: left !important;
                          }
                          .br-right { border-right: 1px solid black !important; }
                          .br-rightt { border-right: 4px solid black !important; }
                          .br-bottom { border-bottom: 2px solid black !important; }
                          .br-top { border-top: 2px solid black !important; }
                          .noPrint { display: none !important; }
                          .footer-line {
                              position: fixed;
                              bottom: 0;
                              left: 0;
                              width: 100%;
                              height: 2px;
                              background-color: black;
                          }
                          thead { display: table-header-group; }
                          tfoot { display: table-footer-group; }
                          td.balance-value {
                              text-align: right !important;
                          }
                      }
                  </style>
              </head>
              <body>
                  <div class="print-section">
                      ${printContent}
                      <div class="footer-line"></div>
                  </div>
                  <script>
                     window.onload = function () {
    const table = document.querySelector('table');
    if (!table) {
        console.error("Table not found");
        return;
    }

    let headerRowIndex = -1;
    const maxRowsToCheck = Math.min(10, table.rows.length);

    // Find header row with column names
    for (let i = 0; i < maxRowsToCheck; i++) {
        const row = table.rows[i];
        const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

        if (row.cells.length >= 8 &&
            (cellTexts.includes('Invoice No') ||
             cellTexts.includes('Receipt No') ||
             cellTexts.includes('Balance'))) {
            headerRowIndex = i;
            break;
        }
    }

    if (headerRowIndex >= 0) {
        // Create thead and move only the actual header row into it
        let thead = table.querySelector('thead');
        if (!thead) {
            thead = document.createElement('thead');
            table.insertBefore(thead, table.firstChild);
        }

        const headerRow = table.rows[headerRowIndex];
        thead.appendChild(headerRow); // move actual header row

        // Leave the other rows (like titles) in tbody so they don’t repeat
    }

    // Alignment processing (no change needed here)
    const cells = document.querySelectorAll('td');
    cells.forEach(cell => {
        const content = cell.textContent.trim();

        if (content.includes('येणे') ||
            content.includes('Opening Balance') ||
            content.match(/^\d+\s+येणे$/) ||
            content.includes('Balance C/F') ||
            content.includes('Total')) {
            cell.style.textAlign = 'right';
            cell.classList.add('balance-value');
        }

        const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
        if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
            cell.style.textAlign = 'right';
            cell.classList.add('amount');
        }
    });

    setTimeout(() => {
        window.print();
        setTimeout(() => { window.close(); }, 500);
    }, 200);
};

                  </script>
              </body>
          </html>
      `);
            printWindow.document.close();
        } else {
            console.error("Failed to open print window.");
        }
    }
}
